export default {
  save: '保存',
  cancel: '取消',
  no_results: '未找到相关地点', 
}